/** Company compliance exemption helpers (spec: 2026-10-05-company-compliance-exemption-design.md). */

/** Same rule sign-in always used, plus: a company with skipTerms never sees the modal. */
export function shouldShowTerms(userDetail: any): boolean {
  if (userDetail?.complianceExemption?.skipTerms === true) {
    return false;
  }
  return (
    !userDetail?.isTermsAccepted &&
    Array.isArray(userDetail?.userPolicyData) &&
    userDetail.userPolicyData.length > 0 &&
    Array.isArray(userDetail.userPolicyData[0]?.policyDocumentData) &&
    userDetail.userPolicyData[0].policyDocumentData.length > 0
  );
}

/** One KYC gate decision for guard, sidenav, layout modal, banner and dashboard. */
export function gatePassed(snap: { loadState: string; status: string; exempt?: boolean } | null | undefined): boolean {
  return !!snap && snap.loadState === 'SUCCESS' && (snap.status === 'APPROVED' || snap.exempt === true);
}

export function daysFromNow(days: number, from: Date = new Date()): Date {
  return new Date(from.getTime() + days * 24 * 60 * 60 * 1000);
}

/** Local midnight `days` days from today (e.g. 1 = tomorrow), for datepicker minimums. */
export function startOfDayFromNow(days: number, from: Date = new Date()): Date {
  const d = daysFromNow(days, from);
  d.setHours(0, 0, 0, 0);
  return d;
}

/**
 * Date part ('YYYY-MM-DD', first 10 chars) of an endsAt / endsAtText value as a
 * LOCAL date, so every screen shows the same calendar day. Null if invalid.
 */
export function toLocalDateOnly(value: string | null | undefined): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value ?? '').slice(0, 10));
  if (!m) {
    return null;
  }
  const y = Number(m[1]);
  const mo = Number(m[2]);
  const d = Number(m[3]);
  const out = new Date(y, mo - 1, d);
  return out.getFullYear() === y && out.getMonth() === mo - 1 && out.getDate() === d ? out : null;
}

/** The picked date's LOCAL calendar day as 'YYYY-MM-DD' (never toISOString). */
export function toDateOnlyString(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
